const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines the content host ratings component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('contentRatingFeedback', ['Application', 'Ratings', '$translate', function(Application, Ratings, $translate) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        workshopInstance: '=?'
      },
      template: require('../../templates/directives/content-rating-feedback.html'),
      controller: ['$scope', function($scope) {
          var self = this;
          self.page = null;
          self.per_page = 20;
          self.translations = {};
          var params = Application.navigation.getRouteParameters();
          self.contentId = params.id;

          self.getRating = function(rating) {
            if (!rating || !rating.percent) {
              return '----';
            }

            var outOfFive = Math.round(rating.percent * 5) / 100;
            if (outOfFive) {
              return outOfFive;
            }

            return '----';
          };

          self.parseUrl = function() {
            var url = Application.navigation.getPath();
            if (/track/g.test(url)) {
              return 'track';
            }
            if (/articles/g.test(url)) {
              return 'article';
            }
            if (/videos/g.test(url)) {
              return 'video';
            }
            if (/files/g.test(url)) {
              return 'file';
            }
            if (/scorm/g.test(url)) {
              return 'scorm';
            }
            if (/imported-content/g.test(url)) {
              return 'imported_content';
            }
            if (/presentations/g.test(url)) {
              return 'presentation';
            }
            return null;
          };

          self.contentType = self.parseUrl();

          self.nextPage = function() {
            if (!self.page || self.page < 0) {
              self.page = 0;
            }

            self.page++;

            if (self.page > 1) {
              self.allowPrevious = true;
            }

            if (self.previousRatings[self.page]) {
              self.ratings = self.previousRatings[self.page];
              if (self.ratings.length < self.per_page) {
                self.allowNext = false;
              }
              return;
            }

            self.loadItems();

          };

          self.previousPage = function(force) {
            if (!self.page || self.page < 2) {
              self.page = 2;
            }

            self.page--;

            self.allowPrevious = false;

            if (self.page > 1) {
              self.allowPrevious = true;
            }

            self.allowNext = true;

            self.ratings = self.previousRatings[self.page];
          };

          self.getLocation = function(user) {
            if (user && user.linked_locations && user.linked_locations[0] && user.linked_locations[0].name) {
              return user.linked_locations[0].name;
            }
            return '-----';
          };

          self.getDepartment = function(user) {
            if (user && user.linked_departments && user.linked_departments[0] && user.linked_departments[0].name) {
              return user.linked_departments[0].name;
            }
            return '-----';
          };

          self.loadItems = function() {
            var query = {content_id: self.contentId,
              page: self.page,
              per_page: self.per_page,
              fields: 'user,percent,rating_date,feedback,content_id,context',
              'user-populate': 'first_name,last_name,full_name,email,image'
            };

            if ($scope.workshopInstance) {
              query['context.value'] = $scope.workshopInstance;
            }

            Ratings.find(query).$promise
            .then(function(results) {
              self.ratings = results;
              self.allowNext = true;
              self.allowPrevious = true;

              if (results.length < self.per_page) {
                self.allowNext = false;
              }

              if (self.page < 2) {
                self.allowPrevious = false;
              }

              self.previousRatings[self.page] = results;

              self.searchLoading = false;
            });
          };

          self.slimDate = function(date) {
            return moment(new Date(date)).format('D-MMM-YYYY');
          };

          self.initialize = function() {
            if (!self.contentId) {
              Application.navigation.goToHome();
              return;
            }
            self.previousRatings = [null];
            self.ratings = [];
            self.nextPage();
          };

          $translate([
            'global.forms.labels_name',
            'global.forms.labels_location',
            'manage.label_department',
            'manage.host.count',
            'manage.host.dateViewed',
            'contentHostViews.search_placeholder'
          ]).then(function(translations) {
            self.translations = translations;
            self.initialize();
          });
        }],
      controllerAs: 'ratingFeedback'
    };
  }]);
